import * as React from "react";
import { SVGProps } from "react";

const NotificationIcon = (props: SVGProps<SVGSVGElement>) => (
  <div className="align-middle group hover:bg-[#D0D4DB] rounded-full  w-[33px] h-[33px] flex items-center justify-center p-1">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33}
      height={33}
      data-name="Component 6434 \u2013 50"
      {...props}
    >
      <path
        fill="#172b4d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.028 19.151a1.323 1.323 0 0 1-.86 2.254 5.29 5.29 0 0 1-5.575-5.575 1.323 1.323 0 0 1 2.148-.96l.108.1 4.179 4.179Z"
        data-name="Path 5434"
      />
      <path
        fill="#172b4d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22.838 1.161a3.971 3.971 0 0 1 .688 4.688l-.119.2-.032.048a10.6 10.6 0 0 1-1.912 9.439l-.242.295-.253.288-2.742 2.74-.106.148a3.968 3.968 0 0 0-.66 2.795l.046.266.06.245a1.323 1.323 0 0 1-2.1 1.39l-.114-.1L.397 8.643a1.322 1.322 0 0 1 1.287-2.21 3.968 3.968 0 0 0 3.303-.553l.153-.114 2.78-2.777a10.58 10.58 0 0 1 9.608-2.46l.368.094.049-.03a3.972 3.972 0 0 1 4.539.254l.185.155.169.159Z"
        data-name="Path 5435"
      />
    </svg>
  </div>
);

export default NotificationIcon;
